import { createDynamicHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { actionsCreator, filtersActions } from './actions.js';
import { initialState } from './store';

interface InitialState {
  appliedFilterData: unknown;
  currentFilterData: unknown;
  changesCount: unknown;
  isChanged: unknown;
}

const {
  Context,
  Provider,
  useCtxStore,
  // NB trick IDE with default value for intellisense to work
  useCtxActions = () => filtersActions
} = createDynamicHookStore<InitialState, ReturnType<typeof actionsCreator>>({
  storeName: STORE_NAMES.FILTERS_STORE,
  initialState,
  actionsCreator
});

export const FiltersContext = Context;

export const FiltersProvider = Provider;

export const useFiltersCtxStore = useCtxStore;

export const useFiltersCtxActions = useCtxActions;
